// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    takeEvery,
    takeLatest,
} from 'redux-saga/effects';

import { checkoutOrderSaga, purchaseOrder, purchaseOnDemandOrder, travelOutcome } from './claimOrder';
import { getPartInfo } from './getPartInfo';
import { getRepairOffer } from './getRepairOffer';
import { saveCustomerComment } from './customerComment';
import { putPartInfo } from './putPartInfo';
import {
    CHECKOUT_ORDER,
    GET_PART_INFO,
    PUT_PART_INFO,
    GET_REPAIR_OFFER,
    PURCHASE_ORDER,
    PURCHASE_ON_DEMAND_ORDER,
    SAVE_CUSTOMER_COMMENTS,
    SAVE_TRAVEL_SR_OUTCOME,
} from './../../../store/orderCreation';

export default [
    takeLatest(CHECKOUT_ORDER, checkoutOrderSaga),
    takeEvery(GET_PART_INFO, getPartInfo),
    takeEvery(PUT_PART_INFO, putPartInfo),
    takeEvery(GET_REPAIR_OFFER, getRepairOffer),
    takeLatest(PURCHASE_ORDER, purchaseOrder),
    takeLatest(PURCHASE_ON_DEMAND_ORDER, purchaseOnDemandOrder),
    takeLatest(SAVE_CUSTOMER_COMMENTS, saveCustomerComment),
    takeLatest(SAVE_TRAVEL_SR_OUTCOME, travelOutcome),
];
